module.exports = __webpack_public_path__ + "static/img/messageBanner.652cc8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/messageBanner.png
// module id = 0f894a3d2a1c04ed
// module chunks = 59